import httpClient from "./httpClient";

class channelService {
    async getChannel() {
        return httpClient("/portals/press/channels");
    }
}

export default new channelService();